/**
 * GLO Color Swatch (Globo) renders solid hex swatches on PDP.
 * This script replaces them with each variant's featured image (same data as collection cards).
 */
(function () {
  function getVariants() {
    const scripts = document.querySelectorAll('script[id^="ProductVariants-"]');
    for (const script of scripts) {
      try {
        const parsed = JSON.parse(script.textContent);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch {
        /* ignore */
      }
    }

    if (window.meta?.product?.variants?.length) {
      return window.meta.product.variants;
    }

    return [];
  }

  function getVariantImageSrc(variant) {
    if (!variant) return null;
    return (
      variant.featured_media?.preview_image?.src ||
      variant.featured_media?.preview_image?.url ||
      variant.featured_media?.src ||
      variant.featured_image?.src ||
      variant.featured_image?.url ||
      null
    );
  }

  function applyVariantImageToGloboLabel(label, src) {
    if (!src) return;

    label.style.setProperty('background-color', 'transparent', 'important');
    label.style.setProperty('background-image', `url("${src}")`, 'important');
    label.style.setProperty('background-size', 'cover', 'important');
    label.style.setProperty('background-position', 'center', 'important');
    label.style.setProperty('background-repeat', 'no-repeat', 'important');
    label.style.setProperty('font-size', '0', 'important');
    label.classList.add('globo-swatch--variant-image');
  }

  function enhanceGloboSwatches() {
    const variants = getVariants();
    if (!variants.length) return false;

    const byId = new Map(variants.map((variant) => [String(variant.id), variant]));
    let updated = 0;

    document.querySelectorAll('li[data-variantid]').forEach((item) => {
      const variantId = item.getAttribute('data-variantid');
      if (!variantId) return;

      const variant = byId.get(String(variantId));
      const src = getVariantImageSrc(variant);
      if (!src) return;

      const label =
        item.querySelector('label.globo-border-color-swatch') ||
        item.querySelector('.globo-border-color-swatch');
      if (!label) return;

      applyVariantImageToGloboLabel(label, src);
      updated += 1;
    });

    return updated > 0;
  }

  function init() {
    enhanceGloboSwatches();

    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const observer = new MutationObserver(() => {
        enhanceGloboSwatches();
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    }

    let attempts = 0;
    const retry = window.setInterval(() => {
      attempts += 1;
      if (enhanceGloboSwatches() || attempts >= 12) {
        window.clearInterval(retry);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
